import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import EntornoLaboral from "../Comun/EntornoLaboral";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import PrintButtonPagoDirecto from "components/blocks/Delta/Buttons/PrintButtonPagoDirecto";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, SheetTextField, SheetHighlightRow, SheetHighlight, formatText, formatDate, formatCurrency, buildEntornoLaboralProps, formatDecimal, formatPercent } from "../SheetLayout";

const PagoDirecto: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const pagoDirectoId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getDirectPayment, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getDirectPayment(userId, prestacionId, pagoDirectoId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Pago Directo"
        icon="credit-card"
        pills={<>
          <SheetPill label="Motivo" value={formatText(d.MotivoPagoDirectoDescripcion)} />
          <SheetPill label="Periodo" value={`${formatDate(d.FechaPeriodoInicial)} → ${formatDate(d.FechaPeriodoFinal)}`} icon="calendar" />
        </>}
        actions={<PrintButtonPagoDirecto dataEconomicSheet={d} disabled={loadingEconomicSheet} />}
      />

      <SheetSection title="Base Cálculo" icon="calculator">
        <SheetGrid>
          <SheetField label="F. Inicio Pago Directo"       value={formatDate(d.FechaInicioPago)} />
          <SheetField label="Motivo Pago Directo"           value={formatText(d.MotivoPagoDirectoDescripcion)} wide />
          <SheetField label="Periodo Inicial"               value={formatDate(d.FechaPeriodoInicial)} />
          <SheetField label="Periodo Final"                 value={formatDate(d.FechaPeriodoFinal)} />
          <SheetField label="Régimen"                       value={formatText(d.RegimenDescripcion)} />
          <SheetField label="Días Devengados"               value={formatText(d.DiasDevengados)} />
          <SheetField label="Base Reg. Diaria"              value={formatCurrency(d.BaseReguladoraDiaria)} />
          <SheetField label="IPREM Diario"                  value={formatCurrency(d.IPREM_Diario)} />
          <SheetField label="N. Hijos Menores 26"           value={formatText(d.TotalHijosMenores26)} />
          <SheetField label="% Reducción Jornada"           value={formatDecimal(d.PorcentajeReduccionJornada)} />
          <SheetField label="% Parcialidad"                 value={formatDecimal(d.PorcentajeParcialidad)} />
          <SheetField label="Cuota Obrera (FAN)"            value={formatDecimal(d.CuotaObrera)} />
          <SheetField label="Importe Cuota Obrera"          value={formatCurrency(d.ImporteCuotaObrera)} />
          <SheetField label="Importe Retenciones"           value={formatCurrency(d.ImporteRetenciones)} />
        </SheetGrid>
      </SheetSection>

      <SheetSection title="Pago" icon="euro">
        <SheetGrid>
          <SheetField label="Importe Por Día"   value={formatCurrency(d.ImporteDia)} />
          <SheetField label="Porcentaje 1"      value={formatDecimal(d.Porcentaje1)} />
          <SheetField label="Porcentaje 2"      value={formatDecimal(d.Porcentaje2)} />
          <SheetField label="Cuenta Bancaria"   value={formatText(d.CuentaBancaria)} wide />
        </SheetGrid>

        <SheetHighlightRow>
          <SheetHighlight label="Bruto"       value={formatCurrency(d.Bruto)}      variant="blue" />
          <SheetHighlight label="Neto"        value={formatCurrency(d.Neto)}       variant="green" />
          <SheetHighlight label="Retenciones" value={formatText(d.Retenciones)}    variant="amber" />
        </SheetHighlightRow>
      </SheetSection>

      <SheetSection title="Resumen" icon="align-left">
        <SheetTextField label="Resumen Automático" value={formatText(d.ResumenAutomatico)} wide />
      </SheetSection>

      {d.entornoLaboral && <EntornoLaboral {...buildEntornoLaboralProps(d)} />}
    </SheetPage>
  );
};

export default PagoDirecto;
